import { initAgentSessionRequest } from 'actions/agentSessions';
import { AgentMessage, Selector } from 'types';

export const getAgentSessionConnectionLoading: Selector<boolean> = (state) =>
  state.agentSessions.loading.includes(initAgentSessionRequest.toString());

export const getActiveSessionId: Selector<string | null> = (state) =>
  state.agentSessions.activeSessionId;

export const getSessionMessages: Selector<AgentMessage[]> = (state) =>
  state.agentSessions.sessionMessages;

export const getConnectionStatus: Selector<string> = (state) => state.agentSessions.status;
